import React from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Row, Col } from 'react-bootstrap'
import SelectLanguage from './SelectLanguage'
import { useLocation } from 'react-router-dom'

import Navbar from './Navbar'

interface Props {
  children?: React.ReactNode
}

const Page = ({ children }: Props): React.ReactElement => {
  const { t } = useTranslation('page')
  const location = useLocation()

  return (
    <div>
      <Navbar />
      <Container>
        <Row className="my-1">
          <Col>
            <div className="float-right">
              <SelectLanguage />
            </div>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <div className="bg-white px-3 py-4 text-vala-blue">
              <span className="h4">
                {location.pathname === '/' && t('yfirlit')}
                {location.pathname === '/skraumsokn' && t('skraUmsokn')}
                {location.pathname === '/umsoknir' && t('umsoknir')}
                {location.pathname === '/skraningar' && t('skraningar')}
                {location.pathname.startsWith('/breytaumsokn') && t('breytaUmsokn')}
                {location.pathname !== '/skraningar' && location.pathname.startsWith('/skraning') && t('skraning')}
                {location.pathname !== '/umsoknir' && location.pathname.startsWith('/umsokn') && t('umsokn')}
              </span>
            </div>
          </Col>
        </Row>
        {children}
      </Container>
    </div>
  )
}

export default Page
